<template>
  <div class="otcDetailOrder-message-container gray-10-bd" v-if="isReady">
    <!-- 总价 -->
    <div class="totalPrice">
      <span class="label">{{ $t("otcDetailOrder.MessTotol") }}</span>
      <span class="value blue-cl">{{ commonData.totalPrice }} {{ commonData.paycoin }}</span>
    </div>
    <div class="infoMessage">
      <div class="left">
        <!-- 单价 -->
        <div class="infoItem">
          <span class="label">{{ $t("otcDetailOrder.MessPrice") }}</span>
          <span class="value main-cl">{{ commonData.price }} {{ commonData.paycoin }}</span>
        </div>
        <!-- 数量 -->
        <div class="infoItem">
          <span class="label">{{ $t("otcDetailOrder.MessVolume") }}</span>
          <span class="value main-cl">{{ commonData.volume }} {{ commonData.coin }}</span>
        </div>
      </div>
      <div class="right">
        <!-- 实名信息 -->
        <div v-if="identificationInfo.otcAuthnameOpen" class="infoItem">
          <span class="label">{{ $t("otcDetailOrder.identification") }}</span>
          <span class="value main-cl">
            <span class="identificationName" @click="onUserNameClicked">{{ identificationInfo.realName }}</span>
            <a class="identification-icon" href="javascript:;" @click="identificationShow">
              <svg-icon icon-class="icon-contact"></svg-icon>
            </a>
          </span>
        </div>
        <!-- 商家备注 -->
        <div class="infoItem">
          <span class="label">{{ $t("otcDetailOrder.MessMerchantRemarks") }}</span>
          <span class="value main-cl">
            <span v-if="showDescription">{{ commonData.description }}</span>
            <span v-else>{{ $t("otcDetailOrder.none") }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCoinShowName } from '@/utils';

export default {
  props: {
    commonData: { default: () => ({}), type: Object },
    // 当前订单 是买数字货币BUY 还是卖数字货币SELL
    isReady: { default: false, type: Boolean },
  },
  methods: {
    getShowCoin(v) {
      let str = v;
      if (this.market && this.market.coinList) {
        str = getCoinShowName(v, this.market.coinList);
      }
      return str;
    },
    identificationShow() {
      this.$emit('update:identificationShow', true);
    },
    onUserNameClicked() {
      this.$emit('userNameClicked');
    },
  },
  computed: {
    market() {
      return this.$store.state.baseData.market;
    },
    identificationInfo() {
      const obj = {
        otcAuthnameOpen: 0,
      };
      const sideMap = {
        SELL: 'buyer',
        BUY: 'seller',
      };
      if (this.commonData.side) {
        const commonData = this.commonData[sideMap[this.commonData.side]];
        if (commonData) {
          obj.realName = commonData.realName;
          obj.mobileNumber = commonData.mobileNumber;
          obj.email = commonData.email;
          if (this.commonData.otcAuthnameOpen) {
            obj.otcAuthnameOpen = Number(this.commonData.otcAuthnameOpen);
          }
        }
      }
      return obj;
    },
    showDescription() {
      let flag = false;
      if (this.commonData.description && this.commonData.description.length) {
        flag = true;
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.otcDetailOrder-message-container {
  padding: 10px 24px 42px;
  border-bottom-width: 1px;
  border-bottom-style: solid;

  .totalPrice {
    margin-top: 12px;
    margin-bottom: 38px;
    display: flex;
    align-items: center;
    gap: 40px;

    .label {
      font-size: 16px;
      min-width: max-content;
    }

    .value {
      font-weight: 600;
      font-size: 30px;
    }
  }

  .infoMessage {
    display: flex;
    align-items: flex-start;
    gap: 80px;

    .infoItem {
      display: flex;
      align-items: flex-start;
      gap: 24px;

      .label {
        font-size: 16px;
        min-width: max-content;
      }

      .value {
        font-size: 16px;
        min-width: 140px;
      }

      .identification-icon {
        margin-left: 8px;
        color: $gray;
        transition: all 0.1s;

        &:hover {
          color: $blue;
        }
      }

      .identificationName {
        cursor: pointer;
        transition: all 0.1s;

        &:hover {
          color: $blue;
        }
      }
    }

    .left, .right {
      display: flex;
      flex-direction: column;
      gap: 28px;
    }
  }
}
</style>
